import { Popover } from 'antd';
import Image from 'global/Image';
import { Flex, Text } from '@deprecated-ui/common';
import { useMemo } from 'react';
import useIsUserSyariah from 'global/TradingModal/hooks/useIsUserSyariah';
import {
  MultiplierChip,
  MultiplierContainer,
  NotationPopoverContainer,
  PopoverBadgeContainer,
  TradingLimitBadge,
} from './styled';

interface IPopoverNotation {
  company: any;
}

const PopoverNotation = ({ company }: IPopoverNotation) => {
  const { day_trade_info: dayTradeInfo, trading_limit_info: tradingLimitInfo } =
    company;
  const { multiplier, is_show_multiplier: isShowMultiplier } =
    dayTradeInfo || {};

  const isUserSyariah = useIsUserSyariah();

  const showMultiplier = useMemo(
    () =>
      [parseInt(multiplier, 10) > 1, isShowMultiplier, !isUserSyariah].every(
        Boolean,
      ),
    [multiplier, isShowMultiplier, isUserSyariah],
  );

  const showTradingLimit = tradingLimitInfo?.is_trading_limit;

  if (!showMultiplier && !showTradingLimit) return null;

  return (
    <Popover
      content={
        <PopoverBadgeContainer>
          {showMultiplier && (
            <>
              <Flex style={{ marginBottom: 2 }}>
                <Text weight="bold">Day Trade</Text>{' '}
                <MultiplierChip
                  className="multiplier-chip"
                  style={{ marginLeft: 4 }}
                >
                  <Image
                    src="/images/day-trade/lightning-filled-company.svg"
                    alt=""
                    height="10"
                    width="10"
                  />

                  <Text size="12px" color="#8277F8" weight="bold">
                    {`${multiplier}x`}
                  </Text>
                </MultiplierChip>
              </Flex>
              <Text height="19px">
                Saham ini bisa dibeli dengan Day Trade dengan nilai hingga{' '}
                {multiplier}x Trading Balance kamu.
              </Text>
              <br />
            </>
          )}
          {showTradingLimit && (
            <>
              <Flex style={{ marginBottom: 2 }}>
                <Text weight="bold">Trading Limit</Text>
                <TradingLimitBadge style={{ marginLeft: 4 }}>
                  TL
                </TradingLimitBadge>
              </Flex>
              <Text height="19px">
                Saham ini bisa dibeli dengan Trading Limit dan dapat dijadikan
                jaminan dengan haircut {tradingLimitInfo?.haircut_percentage}.
              </Text>
            </>
          )}
        </PopoverBadgeContainer>
      }
    >
      <NotationPopoverContainer>
        {showMultiplier && (
          <MultiplierContainer style={{ cursor: 'default' }}>
            <MultiplierChip className="multiplier-chip">
              <Image
                src="/images/day-trade/lightning-filled-company.svg"
                alt=""
                height="10"
                width="10"
              />

              <Text size="12px" color="#8277F8" weight="bold">
                {`${multiplier}x`}
              </Text>
            </MultiplierChip>
          </MultiplierContainer>
        )}

        {showTradingLimit && (
          <TradingLimitBadge
            style={{ cursor: 'default', marginLeft: !showMultiplier ? 8 : 0 }}
          >
            TL
          </TradingLimitBadge>
        )}
      </NotationPopoverContainer>
    </Popover>
  );
};

export default PopoverNotation;
